export const BRAND_NAME = 'Pinkybetco';
export const BRAND_DOMAIN = 'pinkybet.co';
export const PROVIDER = 'Betfair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'krna79.com';